import React from "react"

import Layout from "../components/layout"

const AboutPage = () => (
  <Layout activePath='about' pageTitle="About Us"></Layout>
)

export default AboutPage
